module.exports = __webpack_public_path__ + "static/media/return.564ae46e.svg";